<template>
  <el-dialog
    title="导出指定列"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
    top="10vh"
  >
    <div class="container-dialog">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <el-checkbox-group
        v-model="checkedLine"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox
          v-for="(item, index) in lineList"
          :label="item.en"
          :key="index"
          >{{ item.zh }}</el-checkbox
        >
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="addOrUpdateFun()"
        :loading="exportLoading"
        >导 出</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  taskChooseExportFeildList,
  reportTaskLeftHandleExp
} from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    pictureList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    typeExport: {
      type: [String, Number],
      default: ""
    },
    form: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      exportLoading: false,
      lineList: [],
      checkedLine: [],
      checkAll: false,
      isIndeterminate: true
    };
  },
  mounted() {
    this.taskChooseExportFeildList();
  },
  methods: {
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.lineList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.lineList.length;
    },
    handleCheckAllChange(val) {
      this.checkedLine = val ? this.lineList.map(item => item.en) : [];
      this.isIndeterminate = false;
    },
    async taskChooseExportFeildList() {
      let res = await taskChooseExportFeildList({
        //   eventName: this.form.eventName,
        //   handleState: this.form.handleState,
        //   handleDeptId: this.form.handleDeptId,
        //   pointName: this.form.pointName,
        //   reportUserName: this.form.reportUserName,
        //   keyWord: this.form.keyWord,
        //   reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        //   reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        //   exportFeildList: this.checkedLine,
      });
      if (res.data.code == 200) {
        console.log(res.data.data, 990);
        this.lineList = res.data.data;
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      if (this.checkedLine.length == 0) {
        this.$message.warning("请至少选择一列");
        return;
      }
      this.exportLoading = true;
      let res = await reportTaskLeftHandleExp({
        // eventName: this.form.eventName,
        // handleState: this.form.handleState,
        // handleDeptId: this.form.handleDeptId,
        // pointName: this.form.pointName,
        // reportUserName: this.form.reportUserName,
        // keyWord: this.form.keyWord,
        // reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        // reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        handleDeptId: this.form.handleDeptId,
        pointName: this.form.pointName,
        caseNumber: this.form.caseNumber,
        reportUserName: this.form.reportUserName,
        keyWord: this.form.keyWord,
        reportDeptName: this.form.reportDeptName,
        handleRoleLevelInList: this.form.handleRoleLevelInList || [],
        reportSourceList: this.form.reportSourceList || [],
        eventIndexName: this.form.eventIndexName,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        sqDueTimeStart: this.form.sqDueTime && this.form.sqDueTime[0],
        sqDueTimeEnd: this.form.sqDueTime && this.form.sqDueTime[1],
        ksDueTimeStart: this.form.ksDueTime && this.form.ksDueTime[0],
        ksDueTimeEnd: this.form.ksDueTime && this.form.ksDueTime[1],
        exportFeildList: this.checkedLine
      });
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "问题列表" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();

        this.handleClose();
      } else {
        this.handleClose();
      }
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      this.taskChooseExportFeildList();
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-input {
  width: auto !important;
}
/deep/.el-dialog {
  margin-top: 16vh !important;
}
.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/components/exportSelectionColumn.vue